<template>
  <div>
    <Header></Header>
    <div class="policy-content">
      <h2>{{ $t("policy") }}</h2>
      <h6>
        {{ $t("policyTime1") }}<br />
        {{ $t("policyTime2") }}
      </h6>
      <br />
      <p class="tipfont">
        {{ $t("policy5") }}
      </p>
      <br />
      <h6>{{ $t("policyDes1") }}</h6>
      <br />
      <p class="tipfont">
        {{ $t("policy6") }}<br /><br />
        {{ $t("policy7") }}<br /><br />
        {{ $t("policy8") }}<br />
      </p>
      <br />
      <h6>{{ $t("policy9") }}</h6>
      <p class="tipfont">
        {{ $t("policy10") }}<br />
        {{ $t("policy11") }}<br />
        {{ $t("policy12") }}<br />
        {{ $t("policy13") }}<br />
        {{ $t("policy14") }}<br />
        {{ $t("policy15") }}<br />
        {{ $t("policy16") }}<br />
        {{ $t("policy17") }}<br />
        {{ $t("policy18") }}<br />
        {{ $t("policy19") }}<br />
        {{ $t("policy20") }}<br />
      </p>
      <br />
      <h6>{{ $t("policy212") }}</h6><br />
      <p class="tipfont">{{ $t("policy213") }}</p><br />
      <p class="tipfont">{{ $t("policy214") }}<br /></p>
      <p class="tipfont indent-1">
        {{ $t("policy215") }}<br />
        {{ $t("policy216") }}<br />
        {{ $t("policy217") }}<br />
      </p>
      <p class="tipfont indent-1">{{ $t("policy218") }}</p>
      <p class="tipfont indent-1">
        {{ $t("policy219") }}<br />
        {{ $t("policy220") }}<br />
      </p>
      <p class="tipfont indent-1">{{ $t("policy221") }}</p>
      <p class="tipfont indent-1">
        {{ $t("policy222") }}<br />
        {{ $t("policy223") }}<br />
        {{ $t("policy224") }}<br />
      </p>
      <br />

      <p class="tipfont">{{ $t("policy21") }}</p>
      <br />
      <p class="tipfont">{{ $t("policy22") }}</p>
      <br />
      <p class="tipfont">{{ $t("policy23") }}</p>
      <br />
      <h6>{{ $t("policy24") }}</h6>
      <br />
      <h6>{{ $t("policy27") }}</h6>
      <p class="tipfont indent-1">{{ $t("policy28") }}</p>
      <p class="tipfont indent-2">{{ $t("policy40") }}</p>
      <p class="tipfont indent-2">
        {{ $t("policy41") }}<br />
        {{ $t("policy42") }}<br />
        {{ $t("policy43") }}<br />
        {{ $t("policy44") }}<br />
      </p>
      <p class="tipfont indent-2">{{ $t("policy45") }}</p>
      <p class="tipfont indent-2">{{ $t("policy46") }}</p>
      <p class="tipfont indent-2">{{ $t("policy47") }}</p>
      <p class="tipfont indent-2">{{ $t("policy48") }}</p>
      <p class="tipfont indent-1">
        {{ $t("policy49") }}<br />
        {{ $t("policy50") }}<br />
        {{ $t("policy51") }}<br />
      </p>
      <p class="tipfont indent-2">
        {{ $t("policy52") }}<br />
        {{ $t("policy53") }}<br />
        {{ $t("policy54") }}<br />
        {{ $t("policy55") }}<br />
        {{ $t("policy56") }}<br />
        {{ $t("policy57") }}<br />
      </p>
      <br />
      <h6>{{ $t("policy58") }}</h6>
      <br />
      <p class="tipfont">{{ $t("policy59") }}</p>
      <p class="tipfont indent-1">
        {{ $t("policy60") }}<br />
        {{ $t("policy61") }}<br />
        {{ $t("policy62") }}<br />
        {{ $t("policy63") }}<br />
        {{ $t("policy64") }}<br />
      </p>
      <br />
      <p class="tipfont">{{ $t("policy65") }}</p>
      <br />
      <h6>{{ $t("policy66") }}</h6>
      <br />
      <p class="tipfont">{{ $t("policy68") }}</p>
      <br />
      <p class="tipfont">{{ $t("policy69") }}</p>
      <br />
      <h6>{{ $t("policy70") }}</h6>
      <br />
      <p class="tipfont">{{ $t("policy71") }}</p><br />
      <p class="tipfont">{{ $t("policy72") }}</p>
      <br />
      <h6>{{ $t("policy73") }}</h6>
      <br />
      <p class="tipfont">
        {{ $t("policy74") }}<br /><br />
        {{ $t("policy75") }}<br /><br />
        {{ $t("policy76") }}<br /><br />
        {{ $t("policy77") }}<br /><br />
        {{ $t("policy78") }}<br />
      </p>
      <br />
      <h6>{{ $t("policy79") }}</h6><br />
      <p class="tipfont">{{ $t("policy80") }}</p>
      <br />
      <p class="tipfont">{{ $t("policy81") }}</p>
      <br />

      <h6>{{ $t("policy82") }}</h6><br />
      <p class="tipfont">{{ $t("policy83") }}</p>
      <br />
      <h6>{{ $t("policy84") }}</h6><br />
      <p class="tipfont">{{ $t("policy84-1") }}</p><br />
      <p class="tipfont">{{ $t("policy85") }}</p><br />
      <p class="tipfont">
        {{ $t("policy86") }}<br /><br />
        {{ $t("policy87") }}<br />
      </p>
      <br />
      <h6>{{ $t("policy88") }}</h6><br />
      <p class="tipfont">
        {{ $t("policy89") }}<br /><br />
        {{ $t("policy90") }}<br />
      </p>
      <br />
      <h6>{{ $t("policy91") }}</h6><br />
      <p class="tipfont">
        {{ $t("policy92") }}<br /><br />
        {{ $t("policy93") }}<br /><br />
        {{ $t("policy94") }}<br />
      </p>
      <p class="tipfont indent-1">
        {{ $t("policy95") }}<br />
        {{ $t("policy96") }}<br />
        {{ $t("policy97") }}<br />
        {{ $t("policy140") }}
      </p>
      <p class="tipfont indent-1">{{ $t("policy98") }}</p>
      <p class="tipfont indent-1">{{ $t("policy99") }}</p>
      <p class="tipfont indent-1">{{ $t("policy100") }}</p>
      <br />
      <h6>{{ $t("policy101") }}</h6><br />
      <p class="tipfont">{{ $t("policy141") }}</p>
      <br />
      <p class="tipfont">{{ $t("policy102") }}</p>
      <br />

      <p class="tipfont">{{ $t("policy103") }}</p>
      <br />
      <p class="tipfont">{{ $t("policy104") }}</p>
      <br />
      <p class="tipfont">{{ $t("policy105") }}</p>
      <br />
      <h6>
        {{ $t("policy106") }}
      </h6><br />
      <p class="tipfont">{{ $t("policy107") }}<br /></p><br />
      <h6>{{ $t("policy108") }}</h6><br />
      <p class="tipfont">
        {{ $t("policy109") }}
      </p><br />
      <h6>{{ $t("policy133") }}</h6><br />
      <p class="tipfont">{{ $t("policy110") }}</p><br />
      <h6>{{ $t("policy111") }}</h6><br />
      <p class="tipfont">
        {{ $t("policy112") }}<br />
        {{ $t("policy113") }}<br />
        {{ $t("policy114") }}<br />
        {{ $t("policy115") }}<br />
        {{ $t("policy116") }}<br />
        {{ $t("policy117") }}<br />
      </p><br />
      <h6>
        {{ $t("policy118") }}
      </h6><br />
      <p class="tipfont">{{ $t("policy119") }}</p><br />
      <h6>{{ $t("policy120") }}</h6><br />

      <p class="tipfont">
        {{ $t("policy121") }}
      </p><br />
      <h6>{{ $t("policy122") }}</h6><br />

      <p class="tipfont">
        {{ $t("policy123") }}
      </p><br />
      <h6>
        {{ $t("policy124") }}
      </h6><br />
      <p class="tipfont">
        {{ $t("policy125") }}<br /><br />
        {{ $t("policy126") }}<br /><br />
        {{ $t("policy127") }}<br />
      </p>
      <p class="tipfont indent-1">
        {{ $t("policy200") }}<br />
        {{ $t("policy201") }}<br />
        {{ $t("policy202") }}<br />
        {{ $t("policy203") }}<br />
        {{ $t("policy204") }}<br />
        {{ $t("policy205") }}<br />
        {{ $t("policy206") }}<br />
        {{ $t("policy207") }}<br />
      </p><br />
      <p class="tipfont">{{ $t("policy208") }}<br /></p>
      <br />
      <h6>
        {{ $t("policy209") }}
      </h6><br />
      <p class="tipfont">
        {{ $t("policy210") }}<br /><br />
        {{ $t("policy211") }}<br /><br />
        {{ $t("policy212-1") }}<br /><br />
        {{ $t("policy213-1") }}
      </p>
      <br />
      <h6>
        {{ $t("policy300") }}
      </h6><br />
      <p class="tipfont">
        {{ $t("policy301") }}
      </p>
      <br />
      <h6>
        {{ $t("policy302") }}
      </h6><br />
      <p class="tipfont">
        {{ $t("policy303") }}<br /><br />
        {{ $t("policy304") }}<br /><br />
        {{ $t("policy305") }}<br /><br />
        {{ $t("policy306") }}<br /><br />
        {{ $t("policy307") }}
      </p>
      <br />
      <h6>
        {{ $t("policy308") }}
      </h6><br />
      <p class="tipfont">
        {{ $t("policy309") }}<br /><br />
        {{ $t("policy310") }}<br />
        {{ $t("policy311") }}<br />
        {{ $t("policy312") }}<br />
        {{ $t("policy313") }}<br />
        {{ $t("policy314") }}<br />
        {{ $t("policy315") }}<br />
        {{ $t("policy316") }}
      </p>
      <br />
      <h6>
        {{ $t("policy317") }}
      </h6>
      <p class="tipfont">
        {{ $t("policy318") }}<br />
        {{ $t("policy319") }}<em>{{ $t("policy319-1") }}</em>
        <br />
        {{ $t("policy320") }}<em>{{ $t("policy320-1") }}</em>
        <br />
        {{ $t("policy321") }}<em>{{ $t("policy321-1") }}</em>
        <br />
        {{ $t("policy322") }}<em>{{ $t("policy322-1") }}</em>
        <br />
        {{ $t("policy323") }}<em>{{ $t("policy323-1") }}</em>
        <br />
        {{ $t("policy324") }}
      </p>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.indent-1 {
  padding-left: 1em;
}
.indent-2 {
  padding-left: 2em;
}
.policy-content {
  margin: -40px 138px 80px 138px;
  padding: 50px 50px 40px 60px;
  text-align: left;
  background: rgb(194 191 186 / 10%);
  color: #000;

  @media (max-width: 767px) {
    margin: 0px;
    padding: 50px 20px 50px 24px;

    ul {
      list-style: none;
      font-size: 14px;
      line-height: 28.5px;
      padding-left: 20px !important;
    }
  }
}

h2 {
  font-size: 18px;
  text-align: center;
  margin-top: 0;
  margin-bottom: 40px;
  font-family: OpenSansBold;
  @media (max-width: 767px) {
    font-size: 16px;
    text-align: left;
  }
}

h6 {
  font-size: 16px;
  line-height: 28.5px;
  color: #555;
  font-family: OpenSansBold;
  font-weight: 700;
  @media (max-width: 767px) {
    font-size: 16px;
  }
}

ul {
  list-style: none;
  font-size: 17px;
  line-height: 28.5px;
  padding-left: 19px;
}

.policyDes1 {
  font-size: 20px;
  line-height: 28.5px;
  margin-bottom: 28px;
  font-weight: bold;
}

.tipfont {
  font-size: 16px;
  font-family: OpenSansLight;
  line-height: 28.5px;
  color: #555;
  font-weight: 400;
  white-space: pre-line;
  > em {
    font-weight: 700;
    font-family: OpenSansBold;
    font-style: normal;
  }
  @media (max-width: 767px) {
    font-size: 14px;
  }
}

.smallfont {
  line-height: 28.5px;
  font-size: 18px;
}

.sfbold1 {
  line-height: 28.5px;
  font-size: 18px;
  font-weight: bold;
  margin-top: 40px;
}

.sfbold {
  line-height: 28.5px;
  font-size: 16px;
  color: #555;
  margin-top: 40px;
  font-family: OpenSansBold;
  font-weight: 700;
}

.small {
  font-size: 18px;
  line-height: 28.5px;
  color: #939597;
}

.contant {
  font-size: 18px;
  line-height: 28.5px;
}

.contantp {
  font-size: 18px;
  line-height: 28.5px;
  cursor: pointer;

  a {
    text-decoration: none;
    font-weight: bold;
    color: #000;
  }
}

a {
  cursor: pointer;
  text-decoration: none;
  color: #555;
}
</style>